import React from 'react';
import { Link } from 'react-router-dom';
import { Instagram, Facebook, Twitter, Youtube, Linkedin, MessageCircle } from 'lucide-react';
import logo from '../../assets/efafc.png';

const partenaires = [
  { titre: 'PARTENAIRES MAJEURS', logos: [1, 2] },
  { titre: 'PARTENAIRES OFFICIELS', logos: [1, 2, 3, 4, 5, 6] },
  { titre: 'FOURNISSEURS OFFICIELS', logos: [1, 2] },
  { titre: 'PARTENAIRES INSTITUTIONNELS', logos: [1, 2] },
];

const Footer = () => {
  return (
    <footer className="bg-efafcDark text-white pt-12 pb-6 relative overflow-hidden">
      {/* Decorative top border */}
      <div className="absolute top-0 left-0 w-full h-1 bg-gradient-to-r from-efafcYellow via-efafcGreen to-efafcYellow" />

      <div className="container mx-auto px-4">

        {/* Top Section: Socials */}
        <div className="flex justify-end mb-12">
          <div className="flex items-center gap-4">
            <a href="https://www.instagram.com/efafc_officiel/" target="_blank" rel="noopener noreferrer" className="w-10 h-10 rounded-full bg-white/5 hover:bg-efafcYellow hover:text-efafcDark flex items-center justify-center transition-all duration-300 group">
              <Instagram size={20} />
            </a>
            <a href="https://www.facebook.com/EntenteFeigniesAulnoye" target="_blank" rel="noopener noreferrer" className="w-10 h-10 rounded-full bg-white/5 hover:bg-efafcBlue hover:text-white flex items-center justify-center transition-all duration-300 group">
              <Facebook size={20} />
            </a>
          </div>
        </div>

        {/* Middle Section: Partners */}
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8 mb-16">
          {partenaires.map((cat, idx) => (
            <div key={cat.titre} className="flex flex-col">
              <h3 className="text-efafcYellow font-title font-bold mb-6 text-sm uppercase tracking-wider border-l-4 border-efafcGreen pl-3">
                {cat.titre}
              </h3>
              <div className="flex flex-wrap gap-3">
                {cat.logos.map((_, i) => (
                  <div key={i} className="w-16 h-16 bg-white rounded-xl flex items-center justify-center shadow-lg hover:scale-105 transition-transform duration-300">
                    <span className="text-efafcDark font-bold text-xs">Logo</span>
                  </div>
                ))}
              </div>
            </div>
          ))}
        </div>

        {/* Separator */}
        <div className="w-full h-px bg-white/10 mb-8" />

        {/* Bottom Section: Logo & Links */}
        <div className="flex flex-col md:flex-row items-center justify-between gap-8 mb-8">

          {/* Logo & Name */}
          <div className="flex items-center gap-4">
            <div className="relative">
              <div className="absolute inset-0 bg-efafcYellow blur-lg opacity-20 rounded-full" />
              <img src={logo} alt="Logo EFAFC" className="w-16 h-16 relative z-10 drop-shadow-xl" />
            </div>
            <div className="flex flex-col">
              <span className="text-2xl font-title font-bold text-white tracking-wider">EFAFC</span>
              <span className="text-xs text-gray-400 font-accent uppercase tracking-widest">Entente Feignies Aulnoye</span>
            </div>
          </div>

          {/* Links */}
          <div className="flex flex-wrap justify-center gap-6 text-sm font-medium text-gray-400">
            <Link to="/contact" className="hover:text-efafcYellow transition-colors">Nous contacter</Link>
            <Link to="/mentions-legales" className="hover:text-efafcYellow transition-colors">Mentions légales</Link>
            <Link to="/cgu" className="hover:text-efafcYellow transition-colors">CGU</Link>
            <Link to="/rgpd" className="hover:text-efafcYellow transition-colors">RGPD</Link>
            <Link to="/faq" className="hover:text-efafcYellow transition-colors">F.A.Q</Link>
          </div>
        </div>

        {/* Copyright */}
        <div className="text-center text-xs text-gray-600 font-accent">
          © {new Date().getFullYear()} EFAFC - Tous droits réservés • Site officiel
        </div>

      </div>
    </footer>
  );
};

export default Footer;